import Vue from 'vue'
import Vuex from 'vuex'
import session from './modules/session'
import alert from './modules/alert'
import menu from './modules/menu'
import botsession from './modules/botsession'
import user from './modules/user'
import role from './modules/role'
import permission from './modules/permission'
import chat from './modules/chat'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    alert,
    session,
    menu,
    botsession,
    user,
    role,
    permission,
    chat
  }
})
